import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { TextListModule } from '@libs/src/text-list/text-list.module';
import { TranslationLookupListModule } from '@main-client/src/app/pipes/translation-lookup-list/translation-lookup-list.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';
import { ProfileHubSettingsDialogModule } from '@main-client/src/app/profile/profile-hub-settings-dialog/profile-hub-settings-dialog.module';

import { ProfileGroupItemComponent } from './profile-group-item.component';

@NgModule({
  declarations: [ProfileGroupItemComponent],
  exports: [ProfileGroupItemComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    ProfileHubSettingsDialogModule,
    RouterModule,
    MatTooltipModule,
    TextListModule,
    TranslationLookupModule,
    TranslationLookupListModule,
  ],
})
export class ProfileGroupItemModule {}
